export const getExpirationDate = (hoursFromNow: number) =>
  new Date(Date.now() + hoursFromNow * 3600000);

export const hasExpired = (date: Date) =>
  new Date(date || undefined).getTime() < new Date().getTime();
